/* eslint-disable no-useless-escape */
import { useEffect, useRef } from 'react';
import MathView from 'react-math-view';
import CustomDialog from '../../../../../../components/dialog/CustomDialog';
import './MatchEquationEditorDialog.scss';
import MathEquationTextToSpeechEditor from './MathEquationTextToSpeechEditor';
import { useDomain } from '../../../../../../states/AppDomainProvider';
import { filterUndefined } from '../../../../../../utils/FilterUndefinedObject';

const defaultProps = {
  openDialog: false,
  onApply: () => { },
  onClose: () => { },
  textToRead: null,
  ttsText: {},
};

export default function MatchEquationEditorDialog(props) {
  const mergedProps = { ...defaultProps, ...filterUndefined(props) };
  const { openDialog, onApply, onClose, textToRead, ttsText } = mergedProps;
  const ref = useRef(null);
  // const [state, setState] = useState('');
  const ttsTextRef = useRef({ ...ttsText });
  const { uiDomain, userDomain } = useDomain();
  const { user } = userDomain.domainData;
  const isTtsTextAvailable = user.userModerator || user.unitCreator;

  useEffect(() => {
    if (openDialog) {
      setTimeout(() => {
        const mathField = document.querySelector('math-field');
        if (mathField && mathField.shadowRoot) {
          const virtualKeyboardToggle = mathField.shadowRoot.querySelector('.ML__virtual-keyboard-toggle');
          if (virtualKeyboardToggle) {
            virtualKeyboardToggle.setAttribute('aria-label', 'Toggle Virtual Keyboard');
          }

          const ariaRole = mathField.shadowRoot.querySelector('[aria-role="status"]');
          if (ariaRole) {
            ariaRole.removeAttribute('aria-role');
          }

          const textAriaElement = mathField.shadowRoot.querySelector('.ML__textarea__textarea');
          if (textAriaElement) {
            textAriaElement.setAttribute('aria-label', 'Math input area');
            textAriaElement.setAttribute('name', 'Math input area');
            textAriaElement.removeAttribute('tabindex');
            textAriaElement.removeAttribute('aria-hidden');
          }
        }
      }, 50);
    }
  }, [openDialog]);

  return (
    <CustomDialog
      title='Math Equation Editor'
      openDialog={openDialog}
      onClose={onClose}
      displayCloseIcon
      className='math-editor-container-dialog'
      TransitionProps={{
        onEntered: () => {
          ref.current.focus();
        },
      }}
      content={(
        <div className='math-editor-container' data-test='math-editor-container'>
          <div className='math-container'>
            <MathView
              className='math-view-component'
              // value={state}
              // onChange={(e) => {
              //   setState(e.target.value);
              // }}
              virtualKeyboardMode='manual'
              aria-hidden='false'
              role='main'
              ref={ref}
              tabIndex={0}
            />
          </div>
          {isTtsTextAvailable && (
            <MathEquationTextToSpeechEditor
              text={textToRead}
              ttsText={ttsText}
              onChange={(equationText, value) => {
                ttsTextRef.current[equationText] = value;
              }}
            />
          )}
        </div>
      )}
      actions={[
        {
          title: isTtsTextAvailable ? 'Close' : 'Cancel',
          color: 'primary',
          className: 'btn-danger',
          onClick: onClose,
        },
        {
          title: isTtsTextAvailable ? 'Apply' : 'Add',
          color: 'primary',
          className: 'btn-primary',
          onClick: async () => {
            onApply(ref.current.value, ttsTextRef.current, !isTtsTextAvailable);
            if (isTtsTextAvailable) {
              ref.current.setValue('');
              await uiDomain.showSnackbar(true, 'success', 3000, 'Math equation is updated.');
            }
          },
        },
      ]}
    />
  );
}
